import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';
import { UserPermissions } from '@assets/services/services';
import { IconDirective } from '@coreui/icons-angular';
import {
  ContainerComponent,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective,
} from '@coreui/angular';

import { DefaultFooterComponent, DefaultHeaderComponent } from './';
import { navItems } from './_nav';

function isOverflown(element: HTMLElement) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,

    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,

    RouterOutlet,
    DefaultFooterComponent,
  ],
  providers: [ContainerComponent, IconDirective],
})
export class DefaultLayoutComponent implements OnInit {
  navItems: any = [];

  private userPermission = inject(UserPermissions);

  ngOnInit(): void {
    const x: any = this.userPermission.getInfo();

    // let Finance = x.modules.filter(m => m.moduleId === 1)[0]?.moduleId;
    // let Master = x.modules.filter(m => m.moduleId === 2)[0]?.moduleId;
    // let motorMemo = x.modules.filter(m => m.moduleId === 3)[0]?.moduleId;
    // let admin = x.modules.filter(m => m.moduleId === 4)[0]?.moduleId;
    if (x?.modules) {
      const FinanceAccess = x.modules.filter((x) => x.moduleId == 1);
      const TransportAccess = x.modules.filter((x) => x.moduleId == 2);
      const AuditAccess = x.modules.filter((x) => x.moduleId == 3);
      const AdminAccess = x.modules.filter((x) => x.moduleId == 4);

      this.navItems = navItems({
        isAdmin: AdminAccess.length > 0,
        isAuditor: AuditAccess.length > 0 || FinanceAccess.length > 0,
        isFinance: FinanceAccess.length > 0,
        isTransport: TransportAccess.length > 0,
      });
    }
  }

  onScrollbarUpdate($event: any) {
    // if ($event.verticalUsed) {
    // console.log('verticalUsed', $event.verticalUsed);
    // }
  }
}
